import Bloodhound from './external-adapters/typeaheadJqueryAdapter.js';
import { getS3ProfilePhotoURL } from '../utils/userUtils.js';
import { getURLParam, getURLParams } from '../adapters/dupes/queryParams.js';

export function load() {
    // A/B testing var
    const keywordSuggestType = getURLParam(window.location.search, 'keywordSuggestType') || 'phrases';

    // These URLs need to match the current page's URL, so we start them with a /
    const SCHOOLS_URL = '/teachers/schoolSuggest.html?excludeTestRecords=true&fieldsToSearch=PARTIAL_NAME_AND_LOCATION&max=3&APIKey=' + dcAPIKey;
    const TEACHERS_URL = '/common/teacherSuggest.html?excludeTestRecords=true&fieldsToSearch=PARTIAL_NAME_AND_LOCATION&max=3&APIKey=' + dcAPIKey;
    const KEYWORDS_URL = `/common/keywordSuggest.html?APIKey=${dcAPIKey}&keywordType=${keywordSuggestType}`;

    const appendLatLng = function (url, query) {
        const uri = new Uri(url).replaceQueryParam('keywords', query);

        const params = getURLParams(window.location.href);
        if (params.centerLat && params.centerLng) {
            uri.replaceQueryParam('centerLat', params.centerLat)
                .replaceQueryParam('centerLng', params.centerLng);
        }

        return uri.toString();
    };

    function addSeeMoreLink(data) {
    // Add "see more" entry if there are more results
        const dataLen = data.length;
        if (dataLen > 0 && data[0].totalResults > dataLen) {
            data.push({
                moreResults: data[0].totalResults,
            });
        }
        return data;
    }

    const schools = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('schoolSearch'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 4,
        dupDetector: function (remote, local) {
            return remote.schoolId === local.schoolId;
        },
        remote: {
            url: SCHOOLS_URL,
            replace: appendLatLng,
            filter: addSeeMoreLink,
        },
    });

    const teachers = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('teacherName'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 4,
        dupDetector: function (remote, local) {
            return remote.teacherId === local.teacherId;
        },
        remote: {
            url: TEACHERS_URL,
            replace: appendLatLng,
            filter: function (teachers) {
                if (teachers) {
                    // 68x68 is the size of the smallest teacher profile photo
                    teachers.forEach(function (teacher) {
                        teacher.teacherImage = getS3ProfilePhotoURL(
                            teacher.photoPublished, teacher.photoType, teacher.teacherId, teacher.photoDate,
                            teacher.photoPath, 68, baseCacheURL, baseS3URL,
                            teacher.preFastlyImage, teacher.smartCrop, teacher.xCoord, teacher.yCoord, teacher.cropWidth, teacher.cropHeight);
                    });
                }
                return addSeeMoreLink(teachers);
            },
        },
    });

    const keywords = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 4,
        dupDetector: function (remote, local) {
            return remote.value === local.value;
        },
        prefetch: {
            url: KEYWORDS_URL + '&prefetch=true',
            filter: convertKeywordsToDatums,
        },
    });

    function convertKeywordsToDatums(words) {
        return words && words.map(function (word) {
            return { value: word };
        });
    }

    schools.initialize();
    teachers.initialize();
    keywords.clearPrefetchCache();
    keywords.initialize();

    return {
        schools: schools,
        teachers: teachers,
        keywords: keywords,
    };
}
